//@ts-nocheck
import { combineReducers } from 'redux';
import cases from './cases';

const reducers = () => combineReducers({ cases });

export default reducers;
